import { cn as e } from "../shared/utils.js";
import { PassiveTooltip as t } from "./passive-tooltip.js";
import { forwardRef as n, useEffect as r, useRef as i, useState as a } from "react";
import { jsx as o } from "react/jsx-runtime";
import { useResizeObserver as s } from "usehooks-ts";
//#region src/tooltip/tooltip-text-overflow.tsx
var c = "a[href], button, [role=\"button\"], [role=\"link\"], [role=\"menuitem\"], [role=\"option\"], [tabindex]:not([tabindex=\"-1\"])", l = n(({ children: n, className: l, tooltipContent: u = n, onClick: d, render: f, ...p }, m) => {
	let h = i(null), [g, _] = a(!1), [v, y] = a(!1), { width: b, height: x } = s({ ref: h });
	r(() => {
		let e = h.current;
		_(!!(e && getComputedStyle(e).whiteSpace === "nowrap" && e.scrollWidth > e.clientWidth));
	}, [
		n,
		b,
		x
	]);
	let S = (e) => {
		d?.(e), !e.currentTarget.parentElement?.closest(c) && y((e) => !e);
	}, C = e("inline-block max-w-full min-w-0 truncate align-bottom", l);
	return /* @__PURE__ */ o(t, {
		ref: f ? m : h,
		content: u,
		disabled: !g,
		open: g && v,
		onOpenChange: y,
		positionerProps: {
			align: "center",
			side: "top"
		},
		trigger: f ? /* @__PURE__ */ o("span", {
			ref: h,
			className: C,
			...p,
			children: n
		}) : n,
		triggerProps: f ? {
			render: f,
			closeOnClick: !1
		} : {
			...p,
			closeOnClick: !1,
			onClick: S,
			className: C
		}
	});
});
l.displayName = "TooltipTextOverflow";
//#endregion
export { l as TooltipTextOverflow };
